var map = {
	"./cd.png": 4256,
	"./close.png": 5957,
	"./computerBig.png": 1114,
	"./computerSmall.png": 7253,
	"./credits.png": 4995,
	"./doomIcon.png": 709,
	"./forward.png": 2770,
	"./henordleIcon.png": 1009,
	"./logo.png": 6928,
	"./logo1.png": 4971,
	"./maximize.png": 823,
	"./minimize.png": 4825,
	"./myComputer.png": 1888,
	"./pause.png": 7267,
	"./play.png": 3899,
	"./rewind.png": 292,
	"./scrabbleIcon.png": 1754,
	"./showcaseIcon.png": 273,
	"./trailIcon.png": 4550,
	"./volumeOff.png": 3956,
	"./volumeOn.png": 5288,
	"./windowExplorerIcon.png": 1731,
	"./windowGameIcon.png": 8032,
	"./windowResize.png": 3161,
	"./windowsStartIcon.png": 1927
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5994;